import React from 'react';
import IdNameEntity from './IdNameEntity';
import IdNameActiveEntity from './IdNameActiveEntity';

export default class AdminAgencyEntity extends IdNameActiveEntity {

  static shape = {
    id: React.PropTypes.string.isRequired,
    name: React.PropTypes.string.isRequired,
    region: React.PropTypes.shape(IdNameEntity.shape),
    active: React.PropTypes.bool.isRequired,
    // Denormalized region name
    regionName: React.PropTypes.string.isRequired,
  };

  constructor(item) {
    super(item);
    this.regionName = item.region && item.region.name;
  }

  static newAgency = () => new AdminAgencyEntity({
    name: '',
  });

  static validateName = (name) => {
    if (!name || /^\s*$/.test(name)) {
      return 'Veuillez saisir un nom';
    }
    if (name.length > 32) {
      return 'Le nom doit faire au plus 32 caractères';
    }
    return undefined;
  };
}



// WEBPACK FOOTER //
// ./shared/src/entity/AdminAgencyEntity.js